import request from '@/utils/request'
export function getPageList(data) {
  return request({
    url: 'tenant/GetPageList',
    method: 'post',
    data
  })
}

export function getAll(data) {
  return request({
    url: 'tenant/getAll',
    method: 'post',
    data
  })
}

export function save(data) {
  return request({
    url: 'tenant/save',
    method: 'post',
    data
  })
}

export function changeStatus(data) {
  return request({
    url: 'tenant/changeStatus',
    method: 'post',
    data
  })
}



export function getSingle(data) {
  return request({
    url: 'tenant/getSingle',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: 'tenant/delete',
    method: 'post',
    data
  })
}

